import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Form, message } from "antd";
import dataService from "../networks/api/service/dataService";
import DynamicExcelUpload from "../components/DynamicExcelUpload";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
import CustomTable from "../components/TableComponent/CustomTable";
import UploadButton from "../components/TableComponent/ButtonComponent/UploadButton";
import DownloadButton from "../components/TableComponent/ButtonComponent/DownloadButton";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
const PanchayathList = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [assemblyOptions, setAssemblyOptions] = useState([]);
  const [adminOptions, setAdminOptions] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();

  // Columns for the table
  const columns = [
    {
      title: "Panchayat Name",
      dataIndex: "panchayatName",
      key: "panchayatName",
    },
    {
      title: "Admin Name",
      dataIndex: "adminName",
      key: "adminName",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];

  const getExcelData = async (formData) => {
    console.log(formData, "getExcelData");
    try {
      const res = await dataService.uploadBulkPanchayat(formData);
      if (res.code === 200) {
        getPanchayat();
      }
    } catch (e) { }
  };

  // Show modal for adding or editing
  const showModal = () => {
    setIsModalVisible(true);
  };

  // Handle opening modal for editing
  const handleEdit = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    showModal();
  };

  const downloadSampleFile = () => {
    const worksheet = XLSX.utils.json_to_sheet([
      { "Sl NO": "", CONSTITUENCY: "", ASSEMBLY: "", PANCHAYAT: "" },
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Panchayat_Sample");
    XLSX.writeFile(workbook, "Panchayat_Sample.xlsx");
  };

  // API call to create or update a Panchayat
  const savePanchayat = async (payload) => {
    try {
      if (editingRecord) {
        // Update existing Panchayat
        await dataService.editPanchayat(editingRecord._id, payload);
        message.success("Panchayat updated successfully");
      } else {
        // Create new Panchayat
        await dataService.AddPanchayat(payload);
        message.success("Panchayat added successfully");
      }
      getPanchayat(); // Refresh data
    } catch (e) {
      message.error("Failed to save Panchayat");
    }
  };

  // Handle modal submit
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          panchayatName: values.panchayatName,
          adminId: values.adminId,
          assembly: values.assembly,
        };
        savePanchayat(payload);
        form.resetFields();
        setIsModalVisible(false);
        setEditingRecord(null);
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };

  // Handle modal cancel
  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
    setEditingRecord(null);
  };

  // Fetch Panchayat data and other options
  const getPanchayat = async () => {
    try {
      const res = await dataService.getAllPanchayat();
      if (res.code === 200) {
        setData(res.data);
        setFilteredData(res.data);
      }
    } catch (e) { }
  };

  const getAssembly = async () => {
    try {
      const res = await dataService.getAssemblyForPanchayat();
      if (res.code === 200) {
        setAssemblyOptions(res.data);
      }
    } catch (e) { }
  };

  const getAdmin = async () => {
    try {
      const res = await dataService.getAdminForPanchayat("PANCHAYAT");
      if (res.code === 200) {
        setAdminOptions(res.data);
      }
    } catch (e) { }
  };

  useEffect(() => {
    getPanchayat();
    getAssembly();
    getAdmin();
  }, []);

  // Handle search input change
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = data.filter((item) =>
      item?.panchayatName?.toLowerCase()?.includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <div>
      <h2>Panchayat List</h2>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setEditingRecord(null);
            showModal();
          }}
        >
          Add Panchayat
        </Button>
        <Input.Search
          placeholder="Search by Panchayat Name"
          onChange={handleSearch}
          style={{ width: 200 }}
        />
      </div>

      {/* Table to show Panchayath List */}
      <CustomTable
        dataSource={filteredData}
        columns={columns}
        rowKey={(record) => record._id}
        bordered
        pagination={{ position: ["bottomCenter"], pageSize: 5 }}
        size="middle"
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
        }}
        scroll={{ x: 800 }}
      />

      <div style={{ marginTop: 20 }}>
        <h3>Bulk Upload</h3>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <DownloadButton onClick={downloadSampleFile}>
            Download Sample File
          </DownloadButton>
        </div>
        <DynamicExcelUpload getExcelData={getExcelData} />
      </div>

      {/* Modal for adding/editing Panchayat */}
      <Modal
        title={editingRecord ? "Edit Panchayat" : "Add Panchayat"}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Panchayat Name"
            name="panchayatName"
            rules={[{ required: true, message: "Please enter Panchayat Name" },
            { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}
          >
            <Input placeholder="Enter Panchayat Name" />
          </Form.Item>

          <Form.Item
            label="Admin"
            name="adminId"
            rules={[{ required: true, message: "Please select an Admin" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{ border: "1px solid grey", borderRadius: 5 }}
              placeholder="Select Admin"
            >
              {adminOptions.map((admin) => (
                <Select.Option key={admin._id} value={admin._id}>
                  {admin.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Assembly"
            name="assembly"
            rules={[{ required: true, message: "Please select an Assembly" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{ border: "1px solid grey", borderRadius: 5 }}
              placeholder="Select Assembly"
            >
              {assemblyOptions.map((assembly) => (
                <Select.Option key={assembly._id} value={assembly._id}>
                  {assembly.assemblyName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PanchayathList;
